<div class="container my-3">
  <div class="card shadow-sm">
    <div class="card-body">
      <h3 class="mb-2 title">Select Voucher</h3>

      <form [formGroup]="voucherSectionsForm">
        <div class="mb-3">
          <div class="input-container">
            <label class="label"><input type="checkbox" (change)="toggleFullVoucher($event)" [checked]="isFullVoucherChecked()" name="" class="me-1" id="">Full Voucher</label>
          </div>
          <div class="divider"></div>
          <div class="input-container" *ngIf="voucherSectionsForm.get('hotelsVoucher')?.enabled">
            <label class="label"><input formControlName="hotelsVoucher" type="checkbox" name="" class="me-1" id="">Hotels Voucher</label>
          </div>
          <div class="input-container" *ngIf="voucherSectionsForm.get('transportationVoucher')?.enabled">
            <label class="label"><input formControlName="transportationVoucher" type="checkbox" name="" class="me-1" id="">Transportation Voucher</label>
          </div>
          <div class="input-container" *ngIf="voucherSectionsForm.get('routeCraftVoucher')?.enabled">
            <label class="label"><input formControlName="routeCraftVoucher" type="checkbox" name="" class="me-1" id="">Route Craft Voucher</label>
          </div>
        </div>

        <ion-button type="submit" class="filled-blue-btn" [disabled]="voucherSectionsForm.invalid" (click)="onSubmit()">
          Submit
        </ion-button>
      </form>
    </div>
  </div>
</div>
